import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { UtcToLocalPipe } from '../core/pipe/utc-to-local.pipe';
import {
	NgbNavModule,
	NgbAccordionModule,
	NgbDropdownModule,
	NgbAlertModule,
	NgbModule,
} from '@ng-bootstrap/ng-bootstrap';

// Swiper Slider
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

// Counter
import { CountToModule } from 'angular-count-to';

import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ClientLogoComponent } from './landing/index/client-logo/client-logo.component';
import { ServicesComponent } from './landing/index/services/services.component';
import { CollectionComponent } from './landing/index/collection/collection.component';
import { CtaComponent } from './landing/index/cta/cta.component';
import { DesignedComponent } from './landing/index/designed/designed.component';
import { PlanComponent } from './landing/index/plan/plan.component';
import { FaqsComponent } from './landing/index/faqs/faqs.component';
import { ReviewComponent } from './landing/index/review/review.component';
import { CounterComponent } from './landing/index/counter/counter.component';
import { WorkProcessComponent } from './landing/index/work-process/work-process.component';
import { TeamComponent } from './landing/index/team/team.component';
import { ContactComponent } from './landing/index/contact/contact.component';

import { ScrollspyDirective } from './scrollspy.directive';

// NFT Landing
import { MarketPlaceComponent } from './landing/nft/market-place/market-place.component';
import { WalletComponent } from './landing/nft/wallet/wallet.component';
import { FeaturesComponent } from './landing/nft/features/features.component';
import { CategoriesComponent } from './landing/nft/categories/categories.component';
import { DiscoverComponent } from './landing/nft/discover/discover.component';
import { TopCreatorComponent } from './landing/nft/top-creator/top-creator.component';

//lms
import { DangerMsgComponent } from './common-messages/danger-msg/danger-msg.component';
import { SuccessMsgComponent } from './common-messages/success-msg/success-msg.component';
import { BtnEditPencilComponent } from './btn-edit-pencil/btn-edit-pencil.component';
import { LoaderComponent } from './loader/loader.component';
import { CreditCardAnimationComponent } from './credit-card-animation/credit-card-animation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColumnSelectorComponent } from './column-selector/column-selector.component';
import { RouterModule } from '@angular/router';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ToastComponent } from './toast/toast.component';
import { UploadDocContractComponent } from './upload-doc-contract/upload-doc-contract.component';
import { SelectSearchComponent } from './select-search/select-search.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { LeadDetailsComponent } from './lead-edit/lead-details/lead-details.component';
import { LifecycleCardsComponent } from './lead-edit/lead-details/lifecycle-cards/lifecycle-cards.component';
import { FooterComponent } from './footer/footer.component';
import { BugReportButtonComponent } from './bug-report-button/bug-report-button.component';
import { VeraChatbotComponent } from './vera-chatbot/vera-chatbot.component';
import { NewColumnSelectorComponent } from './new-column-selector/new-column-selector.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
	direction: 'horizontal',
	slidesPerView: 'auto',
};

@NgModule({
	declarations: [
		UtcToLocalPipe,
		BreadcrumbsComponent,
		ClientLogoComponent,
		ServicesComponent,
		CollectionComponent,
		CtaComponent,
		DesignedComponent,
		PlanComponent,
		FaqsComponent,
		ReviewComponent,
		CounterComponent,
		WorkProcessComponent,
		TeamComponent,
		ContactComponent,
		FooterComponent,
		ScrollspyDirective,
		MarketPlaceComponent,
		WalletComponent,
		FeaturesComponent,
		CategoriesComponent,
		DiscoverComponent,
		TopCreatorComponent,
		DangerMsgComponent,
		SuccessMsgComponent,
		BtnEditPencilComponent,
		LoaderComponent,
		CreditCardAnimationComponent,
  		ColumnSelectorComponent,
		ToastComponent,
		UploadDocContractComponent,
  SelectSearchComponent,
  LeadDetailsComponent,
  LifecycleCardsComponent,
  BugReportButtonComponent,
  VeraChatbotComponent,
  NewColumnSelectorComponent,

	],
	imports: [
		FormsModule,
		CommonModule,
		NgbNavModule,
		NgbAccordionModule,
		NgbDropdownModule,
		SwiperModule,
		CountToModule,
		NgbAlertModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		RouterModule,
		NgxDaterangepickerMd.forRoot(),
		NgSelectModule
	],
	exports: [
		UtcToLocalPipe,
		BreadcrumbsComponent,
		ClientLogoComponent,
		ServicesComponent,
		CollectionComponent,
		CtaComponent,
		DesignedComponent,
		PlanComponent,
		FaqsComponent,
		ReviewComponent,
		CounterComponent,
		WorkProcessComponent,
		TeamComponent,
		ContactComponent,
		FooterComponent,
		ScrollspyDirective,
		WalletComponent,
		MarketPlaceComponent,
		FeaturesComponent,
		CategoriesComponent,
		DiscoverComponent,
		TopCreatorComponent,
		DangerMsgComponent,
		SuccessMsgComponent,
		BtnEditPencilComponent,
		LoaderComponent,
		CreditCardAnimationComponent,
		ColumnSelectorComponent,
		ToastComponent,
		UploadDocContractComponent,
		SelectSearchComponent,
		LeadDetailsComponent,
		LifecycleCardsComponent,
		BugReportButtonComponent,
		VeraChatbotComponent,
		NewColumnSelectorComponent,
	],
	providers: [DatePipe],
})
export class SharedModule {}
